export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('setFormOpen');
    },
    closeForm({commit}) {
        commit('setFormClose');
    },
    openXlsxForm({commit}) {
        commit('setXlsxFormOpen');
    },
    closeXlsxForm({commit}) {
        commit('setXlsxFormClose');
    },
    setWikiOpen({commit}) {
        commit('setWikiOpen');
    },
    setWikiClose({commit}) {
        commit('setWikiClose');
    }
}
